import { mapState, mapActions}  from 'vuex';

const decoder = 'TextDecoder' in window ? new TextDecoder() : {
    decode: data => {
        const aBytes = new Uint8Array(data);
        let sView = '';
        for (let nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(
                nPart > 251 && nPart < 254 && nIdx + 5 < nLen ?
                    (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ?
                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ?
                    (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ?
                    (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ?
                    (nPart - 192 << 6) + aBytes[++nIdx] - 128
                : nPart);
        }
        return sView;
    }
};

export default {
    data() {
        return {
            tickle: undefined,
            PING: 'ech+hb',
            hasInitialized: false,
            marketData : {
                7219: '',
                7220: '',
                31: '',
                82: '',
                83: '',
                86: '',
                85: '',
                84: '',
                88: '',
                7286: '' ,
                7287: '' ,
                7288: '' ,
                7295: '' ,
                7296: '' ,
                70: '' ,
                71: '' ,
                7293: '' ,
                7294: '' ,
                87: '' ,
                7282: '' ,
                7284: '' ,
                7283: '' ,
            }
        }
    },
    methods: {
        startWebSocket(conid) {
            console.debug('Starting web socket...');
            this.ws = new WebSocket('wss://' + window.location.host + '/portal.proxy/v1/mkt/ws');
            this.ws.binaryType = 'arraybuffer';
            this.ws.onopen = e => {
                console.debug("Web socket open...");
            }
            this.ws.onmessage = e => {
                if(!this.hasInitialized){
                    this.hasInitialized = true;
                    //console.debug("hasInitialized...............", this.hasInitialized);
                    setTimeout(() => {
                        if (!this.tickle) { //tickle websocket every 20s to keep it open
                            //console.debug('Tickle to keep the websocket open with an interval of 20 seconds');
                            this.tickle = setInterval(() => this.ws.send(this.PING), 20000);
                        }
                        this.subscribe(conid);
                    }, 500);
                    // setTimeout(() => {
                    //     this.chartData(conid);
                    // }, 5000)
                    return;
                }
                const data = decoder.decode(e.data);
                const marketdata_keys = Object.keys(this.marketData);
                if(data != 'ech+hb'){
                    const parsedData = JSON.parse(data);
                    marketdata_keys.forEach(key => {
                        if(key in parsedData){
                            this.marketData[key] = parsedData[key];
                        }
                    })
                }
            }
        },

        subscribe(conid) {
            if (!this.isWSOpen()) return;
            this.ws.send('smd+' + conid + '+{"fields":["7741", "7219", "7220", "31", "82", "83", "86", "85", "84", "88", "7286", "7287", "7288", "7295", "7296", "70", "71", "7293", "7294", "87", "7282", "7284", "7283"], "backout":true}');
        },
        unsubscribe(conid) {
            if (!this.isWSOpen()) return;
            console.debug("Unsubscribing...");
            this.ws.send('umd+' + conid);
            this.closeWebSocket();
        },
        // chartData(conid){
        //     console.debug('Sending web socket request for chart information');
        //     this.ws.send('hdr+' + conid + '+{"period":"5y","bar":"1w","outsideRth":false,"direction":-1,"requestId":0}');
        // },
        isWSOpen() {
            if (!this.ws) return false;
            return this.ws.readyState === this.ws.OPEN;
        },
        closeWebSocket() {
            console.debug('Closing web socket...');
            if (this.ws) {
                this.ws.close();
            }
            if (this.tickle) {
                clearInterval(this.tickle);
            }
        },
        resetValues() {
            Object.keys(this.marketData).forEach(key => {
                this.marketData[key] = '';
            })
        }
    }
};